(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MetierDeleteController',MetierDeleteController);

    MetierDeleteController.$inject = ['$uibModalInstance', 'entity', 'Metier'];

    function MetierDeleteController($uibModalInstance, entity, Metier) {
        var vm = this;

        vm.metier = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Metier.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
